module.exports = __webpack_public_path__ + "media/images/pouchnation-dddec55bf8d81c338655d7716ce466bd.png";